import { DateTime } from 'luxon';

import { Card } from '../../../../DataDisplay';
import { Text } from '../../../../Typography';
import classes from './CalendarDate.module.css';

interface CalendarDateProps {
  /*
    Should be an ISO date string
    */
  date: string;
}

const CalendarDate: React.FC<CalendarDateProps> = ({ date }) => {
  const parsedDate = DateTime.fromISO(date);
  const month = parsedDate.toFormat('MMM').toUpperCase();
  const day = parsedDate.toFormat('dd');

  return (
    <Card className={classes.CalendarDate}>
      {date === 'all' || date === 'multi' ? (
        <Text size="xxxs" fw="600" ta="center">
          {date === 'all' ? 'ALL DAYS' : 'MULTI DAY'}
        </Text>
      ) : (
        <>
          <Text size="xxxs" fw="600">
            {month}
          </Text>
          <Text size="lg" fw="400" mt={-5}>
            {day}
          </Text>
        </>
      )}
    </Card>
  );
};

export { CalendarDate };
